import { toPersianDigits } from './formatters';
import moment from 'jalali-moment';

export function daysUntilLicenseExpiry(value, today = new Date()) {
  if (!value) return null;
  const normalized = String(value).replace(/[۰-۹٠-٩]/g, (digit) =>
    String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit) >= 0
      ? '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)
      : '٠١٢٣٤٥٦٧٨٩'.indexOf(digit)));
  const match = normalized.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
  if (!match) return null;
  let [, year, month, day] = match.map(Number);
  if (year >= 1300 && year < 1500) {
    const jalali = moment.from(`${year}/${month}/${day}`, 'fa', 'jYYYY/jM/jD');
    if (!jalali.isValid()) return null;
    [year, month, day] = jalali.format('YYYY-M-D').split('-').map(Number);
  }
  const expiry = new Date(year, month - 1, day);
  if (expiry.getFullYear() !== year || expiry.getMonth() !== month - 1 || expiry.getDate() !== day) return null;
  return Math.round((Date.UTC(year, month - 1, day) -
    Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())) / 86400000);
}

export function getLicenseStatus(value, today = new Date()) {
  const days = daysUntilLicenseExpiry(value, today);
  if (days === null) return { days, text: 'نامشخص', tone: '' };
  if (days < 0) return { days, text: 'اعتبار سامانه به پایان رسیده', tone: 'expired' };
  if (days === 0) return { days, text: 'امروز آخرین روز اعتبار', tone: 'warning' };
  if (days <= 15) return { days, text: `${toPersianDigits(days)} روز به پایان اعتبار`, tone: 'warning' };
  return { days, text: 'دارای اعتبار', tone: 'active' };
}
